import { useState } from "react";
import {
  Button,
  Card,
  Col,
  Input,
  Row,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import {
  CopyOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import MyPage from "../../../../../../components/pages/Page";
import { useFetch } from "../../../../../../hooks/useFetch";

const buildQuery = (cacheBuster) =>
  cacheBuster
    ? `api/v1/cek_data/reject?t=${cacheBuster}`
    : "api/v1/cek_data/reject";

export default () => {
  const [query, setQuery] = useState("api/v1/cek_data/reject");
  const [keyword, setKeyword] = useState("");
  const [rows, loading] = useFetch(query);

  const doRefresh = () => {
    setQuery(buildQuery(Date.now()));
  };

  // respons API (payload.data): [{ refNumber, nomorKontainer, uraianReject, tanggalReject }]
  const allRows = Array.isArray(rows) ? rows : [];
  const kw = keyword.trim().toLowerCase();
  const filtered = kw
    ? allRows.filter(
        (r) =>
          String(r.refNumber ?? "").toLowerCase().includes(kw) ||
          String(r.nomorKontainer ?? "").toLowerCase().includes(kw) ||
          String(r.uraianReject ?? "").toLowerCase().includes(kw)
      )
    : allRows;
  const dataSource = filtered.map((r, i) => ({
    key: `${r.refNumber}-${i}`,
    no: i + 1,
    ...r,
  }));

  return (
    <MyPage title="Cek Data Reject">
      <Card style={{ marginBottom: 16 }} bodyStyle={{ padding: 16 }}>
        <Row gutter={16} align="middle">
          <Col flex="auto">
            <Input
              placeholder="Cari refNumber..."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              allowClear
            />
          </Col>
          <Col>
            <Button icon={<ReloadOutlined />} onClick={doRefresh} loading={loading}>
              Refresh
            </Button>
          </Col>
        </Row>
      </Card>

      <Card
        title={
          <span>
            Data Reject{" "}
            <Tag color="red" style={{ marginLeft: 8 }}>
              {allRows.length} reject
            </Tag>
          </span>
        }
        extra={
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Menampilkan {filtered.length} dari {allRows.length} data
          </Typography.Text>
        }
        loading={loading}
      >
        <Table
          size="small"
          bordered
          dataSource={dataSource}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "25", "50", "100"],
            showTotal: (t) => `Total ${t} data`,
          }}
          columns={[
            {
              title: "No",
              dataIndex: "no",
              key: "no",
              width: 60,
              align: "center",
            },
            {
              title: "Reference Number",
              dataIndex: "refNumber",
              key: "refNumber",
              width: 200,
              render: (v) => (
                <Typography.Text code copyable={false}>
                  {v ?? "-"}
                </Typography.Text>
              ),
            },
            {
              title: "Uraian Reject",
              dataIndex: "uraianReject",
              key: "uraianReject",
              ellipsis: { showTitle: false },
              render: (v) => (
                <Tooltip title={v} placement="topLeft">
                  <span>{v ?? "-"}</span>
                </Tooltip>
              ),
            },
            {
              title: "Nomor Kontainer",
              dataIndex: "nomorKontainer",
              key: "nomorKontainer",
              width: 150,
              render: (v) => v ?? "-",
            },
            {
              title: "Tanggal Reject",
              dataIndex: "tanggalReject",
              key: "tanggalReject",
              width: 130,
              align: "center",
            },
            {
              title: "Aksi",
              key: "aksi",
              width: 70,
              align: "center",
              render: (_, record) => (
                <Tooltip title="Salin refNumber">
                  <Button
                    size="small"
                    icon={<CopyOutlined />}
                    onClick={() => {
                      if (navigator?.clipboard) {
                        navigator.clipboard.writeText(record.refNumber);
                      }
                    }}
                  />
                </Tooltip>
              ),
            },
          ]}
          scroll={{ x: "max-content" }}
          locale={{ emptyText: "Tidak ada data reject pada periode ini" }}
        />
      </Card>
    </MyPage>
  );
};
